import { isUndefined } from 'angular';

import { Logger } from '@contact/upgrade';

interface Data {
  partials: any[];
}

/**
 * This class is an helper in way to build complex data splitted into several parts.
 * @export
 * @class DataBuilder

 */
export class DataBuilder {
  private dataIndex: { [key: string]: Data } = {};
  private _nbParts: number = 0;

  constructor(private readonly logger: Logger, private readonly onDataCompleted: (id: string, data: any[]) => void, nbParts: number) {
    this._nbParts = nbParts;
  }

  get nbParts(): number {
    return this._nbParts;
  }

  /**
   * Save data part. Notifies 'onDataCompleted' callback when data completed.
   * @param {string} key the key associated to data.
   * @param {*} [partial=1] the data part to save.
   */
  savePartialData(key: string, partial: any = 1): void {
    let data = this.dataIndex[key];
    if (isUndefined(data)) {
      data = this.createData(key);
    }
    data.partials.push(partial);
    this.logger.debug(`[data builder] saved partial data associated to key[${key}] (${data.partials.length}/${this.nbParts}).`);
    this.resolveIfPossible(key, data);
  }

  clear(key: string): void {
    delete this.dataIndex[key];
  }

  private createData(key: string): Data {
    let data = {
      partials: [],
    };
    this.dataIndex[key] = data;
    return data;
  }

  private resolveIfPossible(key: string, data: Data): void {
    if (data.partials.length === this.nbParts) {
      this.onDataCompleted(key, data.partials);
      this.clear(key);
    }
  }
}
